import { FC } from "react";
import ChevronDownIcon from "@heroicons/react/outline/ChevronDownIcon";

import { classNames } from "@utils/class-names";

interface Props {
  text: string;
  open: boolean;
  disabled?: boolean;
}

const FilterButton: FC<Props> = ({ text, open, disabled }) => (
  <div
    className={classNames(
      "flex flex-row border-b-2 border-b-gray-800 w-max p-2 mb-2 m-2 space-x-2 text-sm max-h-10",
      disabled ? "text-gray-600" : ""
    )}
  >
    <div>{text}</div>
    <ChevronDownIcon
      className={classNames(
        "w-5 transition-all duration-300",
        open && !disabled ? "-rotate-180" : ""
      )}
    />
  </div>
);

export default FilterButton;
